// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1JbB2","empty":"ModalGraph_empty__AIzKc"};